import './Footer.css'
import React from 'react'

export default props => 
     <footer className="footer">
          <span>
               Desenvolvido pela CI Sistemas de Informática Ltda. &emsp; &emsp; &emsp; &emsp; (11) 4796-3280
          </span>
          
     </footer>